export const CATEGORIES = [
  "Odontologia",
  "Outros",
];

export const PAYMENT_METHODS = [
  { value: "pix", label: "PIX" },
  { value: "dinheiro", label: "Dinheiro" },
  { value: "cartao_credito", label: "Cartão de Crédito" },
  { value: "cartao_debito", label: "Cartão de Débito" },
  { value: "boleto", label: "Boleto" },
];

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(v || 0);

export const statusLabel = (s) => ({
  open: "Aberto",
  accepted: "Em negociação",
  completed: "Concluído",
  cancelled: "Cancelado",
  expired: "Expirado",
}[s] || s);

export const statusColor = (s) => ({
  open: "bg-primary/20 text-primary border-primary/30",
  accepted: "bg-amber-500/20 text-amber-500 border-amber-500/30",
  completed: "bg-emerald-500/20 text-emerald-500 border-emerald-500/30",
  cancelled: "bg-red-500/20 text-red-500 border-red-500/30",
  expired: "bg-zinc-500/20 text-zinc-400 border-zinc-500/30",
}[s] || "bg-muted");
